<template>
  <div class="sort-order">
    <div class="sort-title">Sort Order</div>

    <div class="sort-control">
      <b-button variant="light" class="sort-btn">
        <font-awesome-icon
          icon="sort-down"
          class="sort-icon down"
          @click="$emit('onClickDown')"
        />
      </b-button>

      <span class="sort-value">{{ value }}</span>

      <b-button variant="dark" class="sort-btn">
        <font-awesome-icon
          icon="sort-up"
          class="sort-icon up"
          @click="$emit('onClickUp')"
        />
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Stepper",
  props: {
    value: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="scss" scoped>
.sort-order {
  border-radius: 12px;
}

.sort-title {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 8px;
}

.sort-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.sort-btn {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sort-btn i {
  font-size: 18px;
}

.sort-value {
  font-size: 20px;
  font-weight: 600;
  min-width: 20px;
  text-align: center;
}
</style>
